'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllAgentResponders = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAllAgentResponders = exports.getAllAgentResponders = (0, _getIn2.default)(['responders', _senderTypes.AGENT]);


//////////////////
// WEBPACK FOOTER
// ./js/responders/selectors/getAllAgentResponders.js
// module id = 265
// module chunks = 2 3